export default __webpack_public_path__ + "static/media/google_playstore_icon.5aa82908.png";